import { AdvancedSearchJobsState } from './partials/search-jobs'
import { createSearchResults } from './util'

export const AdvancedSearchState = () => ({
  embeddedSearchQuery: null,
  entities: [],
  entity: null,
  exportable_fields_query: [],
  exportable_fields: [],
  indistinctResults: false,
  interGroupOperator: 'AND',
  isSearching: false,
  loadedJob: null,
  loadingAdvancedSearch: false,
  query_groups: [],
  search_results: createSearchResults(),
  searched_query_groups: [],
  searchJobs: AdvancedSearchJobsState,
  selected_results: [],
  show_export_dialog: false,
})
